import { truncate } from 'lodash-es';
import type { ExecutionResultWithData } from '@soundxyz/graphql-react-query';
import { GraphQLReactQueryClient } from '@soundxyz/graphql-react-query';
import {
  defaultContext,
  QueryClient,
  QueryClientProvider,
  useQuery as useReactQuery,
} from '@soundxyz/graphql-react-query/reactQuery';
import { IS_TEST } from '@soundxyz/utils/const';
import { graphqlClientHeaders } from '@context/headers';
import { GATEWAY_API_URL } from '@utils/env';
import type { OperationNames, Operations } from './generated/documents';

export {
  type ExecutionResultWithData,
  defaultContext,
  QueryClient,
  QueryClientProvider,
  useReactQuery,
};
export type { ResultOf, VariablesOf } from '@soundxyz/gql-string';

export const GQLReactQuery = GraphQLReactQueryClient<Operations, OperationNames>({
  endpoint: GATEWAY_API_URL,
  headers: graphqlClientHeaders,
  fetcher: IS_TEST
    ? ({ query }) => {
        throw Error(`Root fetcher mock has not been set for ${truncate(query, { length: 40 })}`);
      }
    : undefined,
  clientConfig: IS_TEST
    ? {
        defaultOptions: {
          queries: {
            retry: false,
          },
        },
      }
    : {},
  skipAbort: true,
});

export const {
  GraphQLReactQueryProvider,
  client: GraphQLReactQuery,
  fetchGQL,
  invalidateOperations,
  resetOperations,
  useInfiniteQuery,
  useMutation,
  useQuery,
  setQueryData,
  setInfiniteQueryData,
  infiniteQueryKey,
  fetchQuery,
  prefetchQuery,
  Effects: ReactQueryEffects,
} = GQLReactQuery;
